module.exports = __webpack_public_path__ + "static/media/talk00_small@2x.cc56afad.jpg";